import {useMutation} from "@khan/data-gql";

import {ARCHIVE_COEDITING_DOCUMENT_MUTATION} from "../graphql/archive-coediting-document-mutation.ts";

export const useArchiveDocumentMutation = () => {
    const [archiveDocumentMutation] = useMutation(
        ARCHIVE_COEDITING_DOCUMENT_MUTATION,
    );

    return archiveDocumentMutation;
};
